import { toNote } from '@/lib/link'
import { cn } from '@/lib/utils'
import { Event } from '@nostr/tools/wasm'
import { useTranslation } from 'react-i18next'

export default function TorrentPreview({ event, className }: { event: Event; className?: string }) {
  const { t } = useTranslation()
  const title = event.tags.find(([name]) => name === 'title')?.[1]

  return (
    <div className={cn('pointer-events-none', className)}>
      [{t('Torrent')}]{' '}
      <a href={toNote(event)} onClick={(e) => e.preventDefault()} className="italic pr-0.5">
        {title || event.content}
      </a>
    </div>
  )
}
